import * as React from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";

import { inputsCustomizations } from "./customizations/inputs";
import { dataDisplayCustomizations } from "./customizations/dataDisplay";
import { feedbackCustomizations } from "./customizations/feedback";
import { navigationCustomizations } from "./customizations/navigation";
import { surfacesCustomizations } from "./customizations/surfaces";

import { colorSchemes, typography, shadows, shape } from "./themePrimitives";

export default function AppTheme({ children, disableCustomTheme, themeComponents }) {
  
  const theme = React.useMemo(() => {
    return disableCustomTheme
      ? {}
      : createTheme({
          palette: colorSchemes.light.palette,
          typography,
          shadows,
          shape,
          components: {
            ...inputsCustomizations,
            ...dataDisplayCustomizations,
            ...feedbackCustomizations,
            ...navigationCustomizations,
            ...surfacesCustomizations,
            ...themeComponents,
          },
        });
  }, [disableCustomTheme, themeComponents]);


  if (disableCustomTheme) return children;

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}
